import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { isNil } from '@trimble-gcs/common';
import { SetLicenses } from './license.actions';
import { License, LicenseStatus } from './license.models';

export interface LicenseStateModel {
  licenses?: License[];
}

@State<LicenseStateModel>({
  name: 'licenseState',
})
@Injectable()
export class LicenseState {
  @Selector() static hasActiveLicense(state: LicenseStateModel): boolean {
    if (isNil(state.licenses)) return false;

    // Only evaluate license against Active status. The API grants a grace period which
    // may result in the endDate having past but the license remaining active for
    // x number of days. The API will also mark the license as InActive if the
    // startDate is in the future.
    return state.licenses.some((license) => license.status === LicenseStatus.Active);
  }

  @Selector() static licenses(state: LicenseStateModel) {
    return state.licenses;
  }

  @Action(SetLicenses) setLicenses(ctx: StateContext<LicenseStateModel>, action: SetLicenses) {
    ctx.patchState({ licenses: action.licenses });
  }
}
